import React from 'react';
import { ElementSelector } from '@bingads-webui-campaign-react/element-selector';
import { CampaignPageMenuPlaceholder } from '@bingads-webui-campaign-react/shell-ui-common';

import { CampaignPageMenuLoader } from './campaign-page-menu-loader';
import { AccountsPageMenuLoader } from './accounts-page-menu-loader';
import { BulkOperationPageMenuLoader } from './bulk-operation-menu-loader';
import { BusinessDataPageMenuLoader } from './business-data-page-menu-loader';
import { HotelCenterPageMenuLoader } from './hotel-center-page-menu-loader';
import { HotelCenterV2PageMenuLoader } from './hotel-center-v2-page-menu-loader';
import { MerchantCenterPageMenuLoader } from './merchant-center-page-menu-loader';
import { BidStrategiesPageMenuLoader } from './bid-strategies-menu-loader';
import { UetPageMenuLoader } from './uet-tag-page-menu-loader';
import { AssetLibraryPageMenuLoader } from './asset-library-page-menu-loader';

export const PageMenuContainer = React.memo(props => (
  <ElementSelector fallback={(<CampaignPageMenuPlaceholder />)}>
    <AccountsPageMenuLoader {...props} />
    <BidStrategiesPageMenuLoader {...props} />
    <CampaignPageMenuLoader {...props} />
    <BusinessDataPageMenuLoader {...props} />
    <BulkOperationPageMenuLoader {...props} />
    <HotelCenterPageMenuLoader {...props} />
    <HotelCenterV2PageMenuLoader {...props} />
    <MerchantCenterPageMenuLoader {...props} />
    <UetPageMenuLoader {...props} />
    <AssetLibraryPageMenuLoader {...props} />
  </ElementSelector>
));
